import apiAsync from 'infrastructure/shared/api/api-async'
import {
  PostProcessPayload,
  PostProcessResponse
} from '../types/postProcess.type'

export const postProcess = (
  payload: PostProcessPayload,
  showLoading = true
): Promise<PostProcessResponse> => {
  return apiAsync.requestSync({
    endpoint: 'msPlatform',
    path: 'processes',
    method: 'POST',
    showLoading: showLoading,
    obj: {
      processmodel_uuid: payload.processmodel_uuid,
      data_container: {
        CLIENT_TRACKING: payload.clientTracking,
        ...payload.dataContainerParams
      }
    }
  })
}
